export const getLandingPageFAQStyles = () => ({
  container: {
    width: '100%',
    '& .faq-container': {
      background: '#FAFAFA',
    },
    '& .panel-body': {
      lineHeight: '1.5',
    },
  },
});
